import React from 'react';

// Illustrations d'objets d'études pour la page d'accueil.
// Style : aplats de couleurs du blog, contours encre, ombres décalées (comme les cartes du site).

const C = {
  ink: '#1a1814',
  cream: '#f5f0e8',
  creamDeep: '#ebe2d2',
  terracotta: '#8c1c3a',
  olive: '#5b6b3a',
  oliveLight: '#a9bb73',
  sun: '#f2b544',
  blush: '#e6b8c4',
  line: '#d8ccb6',
};
const S = { stroke: C.ink, strokeWidth: 3, strokeLinejoin: 'round', strokeLinecap: 'round' };

export function Laptop(props) {
  const base = 'M10 172 H298 L284 196 Q282 201 275 201 H33 Q26 201 24 196 Z';
  return (
    <svg viewBox="0 0 320 215" {...props} aria-hidden="true">
      {/* ombres */}
      <rect x="47" y="27" width="228" height="150" rx="12" fill={C.ink} />
      <path d={base} transform="translate(6 6)" fill={C.ink} />
      {/* écran */}
      <rect x="40" y="20" width="228" height="150" rx="12" fill={C.cream} {...S} />
      <rect x="54" y="34" width="200" height="122" rx="6" fill={C.ink} />
      <circle cx="67" cy="46" r="4" fill={C.terracotta} />
      <circle cx="79" cy="46" r="4" fill={C.sun} />
      <circle cx="91" cy="46" r="4" fill={C.oliveLight} />
      {/* lignes de code */}
      <rect x="66" y="62" width="54" height="7" rx="3.5" fill={C.sun} />
      <rect x="126" y="62" width="34" height="7" rx="3.5" fill={C.blush} />
      <rect x="78" y="76" width="70" height="7" rx="3.5" fill={C.oliveLight} />
      <rect x="78" y="90" width="44" height="7" rx="3.5" fill={C.terracotta} />
      <rect x="128" y="90" width="26" height="7" rx="3.5" fill={C.cream} opacity=".55" />
      <rect x="66" y="104" width="38" height="7" rx="3.5" fill={C.blush} />
      <rect x="66" y="118" width="62" height="7" rx="3.5" fill={C.cream} opacity=".55" />
      <rect className="so-cursor" x="132" y="118" width="4" height="10" fill={C.sun} />
      {/* mini carte QCM */}
      <rect x="176" y="62" width="66" height="78" rx="5" fill={C.cream} />
      <rect x="184" y="70" width="40" height="5" rx="2.5" fill={C.ink} opacity=".7" />
      <rect x="184" y="84" width="9" height="9" rx="2" fill="none" stroke={C.ink} strokeWidth="2" />
      <rect x="198" y="86" width="32" height="5" rx="2.5" fill={C.line} />
      <rect x="184" y="100" width="9" height="9" rx="2" fill={C.olive} />
      <path d="M186 104.5 l2.5 2.5 l4.5 -5" fill="none" stroke={C.cream} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="198" y="102" width="26" height="5" rx="2.5" fill={C.line} />
      <rect x="184" y="116" width="9" height="9" rx="2" fill="none" stroke={C.ink} strokeWidth="2" />
      <rect x="198" y="118" width="34" height="5" rx="2.5" fill={C.line} />
      {/* base */}
      <path d={base} fill={C.creamDeep} {...S} />
      <path d="M128 172 Q131 180 140 180 H168 Q177 180 180 172" fill={C.cream} {...S} strokeWidth="2.5" />
    </svg>
  );
}

export function DeskLamp(props) {
  return (
    <svg viewBox="0 0 240 250" {...props} aria-hidden="true">
      {/* halo de lumière */}
      <path className="so-light" d="M142 118 L112 248 L238 248 L182 92 Z" fill={C.sun} opacity=".32" />
      {/* socle */}
      <ellipse cx="56" cy="238" rx="44" ry="9" fill={C.ink} />
      <path d="M16 232 Q16 212 56 212 Q96 212 96 232 Z" fill={C.olive} {...S} />
      {/* bras articulé */}
      <path d="M56 214 L38 138 L114 74" fill="none" stroke={C.ink} strokeWidth="9" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M56 214 L38 138 L114 74" fill="none" stroke={C.creamDeep} strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="38" cy="138" r="8" fill={C.terracotta} {...S} />
      <circle cx="56" cy="212" r="7" fill={C.sun} {...S} />
      {/* abat-jour */}
      <path d="M110 64 L128 52 L188 96 Q176 120 146 126 Z" transform="translate(5 5)" fill={C.ink} />
      <path d="M110 64 L128 52 L188 96 Q176 120 146 126 Z" fill={C.terracotta} {...S} />
      <path d="M124 64 L170 98" stroke={C.cream} strokeWidth="3" strokeLinecap="round" opacity=".5" />
      <circle cx="114" cy="74" r="8" fill={C.terracotta} {...S} />
      <circle cx="166" cy="114" r="9" fill={C.sun} {...S} />
    </svg>
  );
}

export function BookStack(props) {
  return (
    <svg viewBox="0 0 240 175" {...props} aria-hidden="true">
      <ellipse cx="122" cy="164" rx="108" ry="8" fill={C.ink} opacity=".18" />
      {/* livre du bas */}
      <rect x="26" y="124" width="200" height="38" rx="4" fill={C.ink} transform="translate(5 4)" />
      <rect className="so-book-dark" x="20" y="120" width="200" height="38" rx="4" fill={C.ink} {...S} />
      <rect x="198" y="126" width="16" height="26" rx="2" fill={C.cream} {...S} strokeWidth="2" />
      <rect x="40" y="120" width="10" height="38" fill={C.sun} />
      <rect x="62" y="133" width="80" height="5" rx="2.5" fill={C.cream} opacity=".8" />
      <rect x="62" y="143" width="50" height="4" rx="2" fill={C.cream} opacity=".5" />
      {/* livre du milieu */}
      <rect x="34" y="84" width="180" height="36" rx="4" fill={C.olive} {...S} />
      <rect x="192" y="90" width="16" height="24" rx="2" fill={C.cream} {...S} strokeWidth="2" />
      <rect x="62" y="93" width="78" height="18" rx="3" fill={C.cream} {...S} strokeWidth="2" />
      <rect x="70" y="99" width="46" height="5" rx="2.5" fill={C.ink} opacity=".6" />
      <rect x="156" y="84" width="8" height="36" fill={C.sun} />
      {/* livre du haut, de travers */}
      <g transform="rotate(-5 116 66)">
        <rect x="30" y="52" width="170" height="32" rx="4" fill={C.blush} {...S} />
        <rect x="180" y="57" width="14" height="22" rx="2" fill={C.cream} {...S} strokeWidth="2" />
        <rect x="48" y="52" width="8" height="32" fill={C.terracotta} />
        <rect x="70" y="64" width="60" height="5" rx="2.5" fill={C.ink} opacity=".55" />
      </g>
      {/* pomme */}
      <path d="M150 50 Q132 50 132 33 Q132 18 146 18 Q151 18 155 21 Q159 18 164 18 Q178 18 178 33 Q178 50 160 50 Q155 47 150 50 Z" fill={C.terracotta} {...S} />
      <path d="M155 21 Q154 12 159 7" fill="none" {...S} />
      <path d="M158 12 Q168 4 174 10 Q166 16 158 12 Z" fill={C.oliveLight} {...S} strokeWidth="2.5" />
      <path d="M140 28 Q142 24 146 23" fill="none" stroke={C.cream} strokeWidth="3" strokeLinecap="round" opacity=".7" />
    </svg>
  );
}

export function Mug(props) {
  return (
    <svg viewBox="0 0 150 175" {...props} aria-hidden="true">
      {/* vapeur */}
      <g className="so-steam" fill="none" stroke={C.ink} strokeWidth="3" strokeLinecap="round" opacity=".55">
        <path d="M46 56 Q38 44 46 34 Q54 24 46 12" />
        <path d="M66 56 Q58 42 66 30 Q74 18 66 6" />
        <path d="M86 56 Q78 44 86 34 Q94 24 86 12" />
      </g>
      <ellipse cx="68" cy="164" rx="58" ry="8" fill={C.ink} />
      <ellipse cx="66" cy="160" rx="56" ry="8" fill={C.cream} {...S} />
      {/* anse */}
      <path d="M106 84 Q136 84 136 108 Q136 132 106 130" fill="none" stroke={C.ink} strokeWidth="10" strokeLinecap="round" />
      <path d="M106 84 Q136 84 136 108 Q136 132 106 130" fill="none" stroke={C.blush} strokeWidth="3" strokeLinecap="round" />
      {/* corps */}
      <path d="M30 72 H112 V138 Q112 156 92 156 H50 Q30 156 30 138 Z" transform="translate(5 3)" fill={C.ink} />
      <path d="M26 68 H108 V136 Q108 156 88 156 H46 Q26 156 26 136 Z" fill={C.blush} {...S} />
      <path d="M26 68 H108" {...S} />
      <path d="M67 128 C52 118 50 106 59 102 C64 100 67 104 67 106 C67 104 70 100 75 102 C84 106 82 118 67 128 Z" fill={C.terracotta} {...S} strokeWidth="2.5" />
      <path d="M38 80 V120" stroke={C.cream} strokeWidth="4" strokeLinecap="round" opacity=".6" />
    </svg>
  );
}

function Pencil({ x, y, rot, body, tip = C.creamDeep, len = 116 }) {
  return (
    <g transform={`translate(${x} ${y}) rotate(${rot})`}>
      <rect x="0" y="0" width="18" height={len} fill={body} {...S} />
      <path d={`M6 0 V${len}`} stroke={C.ink} strokeWidth="1.5" opacity=".25" />
      <path d="M0 0 L9 -26 L18 0 Z" fill={tip} {...S} />
      <path d="M5.5 -16 L9 -26 L12.5 -16 Z" fill={C.ink} />
    </g>
  );
}

export function PencilCup(props) {
  return (
    <svg viewBox="0 0 160 230" {...props} aria-hidden="true">
      <Pencil x={42} y={52} rot={-14} body={C.sun} />
      <Pencil x={70} y={34} rot={3} body={C.terracotta} len={120} />
      <Pencil x={96} y={50} rot={16} body={C.oliveLight} />
      {/* règle */}
      <g transform="translate(108 78) rotate(28)">
        <rect x="0" y="0" width="16" height="92" fill={C.cream} {...S} strokeWidth="2.5" />
        {[10, 22, 34, 46, 58, 70].map(t => <path key={t} d={`M0 ${t} H7`} stroke={C.ink} strokeWidth="2" />)}
      </g>
      {/* pot */}
      <path d="M36 116 H128 L120 212 Q119 219 111 219 H53 Q45 219 44 212 Z" transform="translate(5 4)" fill={C.ink} />
      <path d="M32 112 H124 L116 208 Q115 215 107 215 H49 Q41 215 40 208 Z" fill={C.olive} {...S} />
      <path d="M30 112 H126" {...S} strokeWidth="4" />
      {[[56, 140], [80, 150], [104, 140], [64, 176], [92, 182], [78, 198]].map(([cx, cy]) => (
        <circle key={`${cx}-${cy}`} cx={cx} cy={cy} r="4.5" fill={C.cream} opacity=".8" />
      ))}
    </svg>
  );
}

export function Notebook(props) {
  const lines = [44, 60, 76, 92, 108, 124, 140];
  return (
    <svg viewBox="0 0 240 185" {...props} aria-hidden="true">
      <rect x="20" y="24" width="208" height="150" rx="8" fill={C.ink} />
      <rect x="14" y="18" width="208" height="150" rx="8" fill={C.terracotta} {...S} />
      <rect x="22" y="10" width="96" height="150" rx="4" fill={C.cream} {...S} />
      <rect x="118" y="10" width="96" height="150" rx="4" fill={C.cream} {...S} />
      {lines.map(y => <path key={`l${y}`} d={`M30 ${y} H110`} stroke={C.line} strokeWidth="2" />)}
      {lines.map(y => <path key={`r${y}`} d={`M126 ${y} H206`} stroke={C.line} strokeWidth="2" />)}
      <path d="M40 18 V156" stroke={C.terracotta} strokeWidth="1.5" opacity=".6" />
      {/* notes manuscrites */}
      <text x="48" y="56" fontFamily="Fraunces, Georgia, serif" fontStyle="italic" fontSize="17" fill={C.ink}>f'(x)=</text>
      <text x="56" y="88" fontFamily="Fraunces, Georgia, serif" fontStyle="italic" fontSize="17" fill={C.terracotta}>eˣ + √2</text>
      <path d="M48 112 Q62 100 76 112 T104 112" fill="none" stroke={C.olive} strokeWidth="2.5" strokeLinecap="round" />
      <path d="M48 134 H96" stroke={C.ink} strokeWidth="2.5" strokeLinecap="round" opacity=".6" />
      {/* liste cochée */}
      {[40, 72, 104].map((y, i) => (
        <g key={y}>
          <rect x="132" y={y - 10} width="12" height="12" rx="2" fill={i < 2 ? C.olive : 'none'} stroke={C.ink} strokeWidth="2" />
          {i < 2 && <path d={`M134.5 ${y - 4} l3 3 l5 -6`} fill="none" stroke={C.cream} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />}
          <rect x="150" y={y - 7} width={i === 1 ? 34 : 46} height="6" rx="3" fill={C.ink} opacity=".5" />
        </g>
      ))}
      {/* étoile */}
      <path d="M178 122 l5 11 l12 1 l-9 8 l3 12 l-11 -6 l-11 6 l3 -12 l-9 -8 l12 -1 Z" fill={C.sun} {...S} strokeWidth="2.5" />
      {/* spirale */}
      {[22, 38, 54, 70, 86, 102, 118, 134, 150].map(y => (
        <ellipse key={y} cx="118" cy={y} rx="7" ry="3.5" fill="none" stroke={C.ink} strokeWidth="2.5" />
      ))}
      {/* marque-page */}
      <path d="M192 4 V40 L199 33 L206 40 V4 Z" fill={C.olive} {...S} strokeWidth="2.5" />
    </svg>
  );
}

export function Glasses(props) {
  return (
    <svg viewBox="0 0 210 90" {...props} aria-hidden="true">
      <path d="M28 40 L8 26" {...S} strokeWidth="5" />
      <path d="M182 40 L202 26" {...S} strokeWidth="5" />
      <path d="M82 40 Q105 26 128 40" fill="none" {...S} strokeWidth="5" />
      <circle cx="58" cy="48" r="30" fill="#f6e1e7" {...S} strokeWidth="5" />
      <circle cx="152" cy="48" r="30" fill="#f6e1e7" {...S} strokeWidth="5" />
      <path d="M42 36 Q48 28 58 27" fill="none" stroke={C.cream} strokeWidth="4" strokeLinecap="round" />
      <path d="M136 36 Q142 28 152 27" fill="none" stroke={C.cream} strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}

export function Sparkle({ color = C.sun, ...props }) {
  return (
    <svg viewBox="0 0 40 40" {...props} aria-hidden="true">
      <path d="M20 2 Q22 18 38 20 Q22 22 20 38 Q18 22 2 20 Q18 18 20 2 Z" fill={color} {...S} strokeWidth="2.5" />
    </svg>
  );
}

export function Bubble({ children, ...props }) {
  return (
    <svg viewBox="0 0 130 90" {...props} aria-hidden="true">
      <path d="M14 10 H120 Q126 10 126 16 V58 Q126 64 120 64 H52 L30 84 L34 64 H14 Q8 64 8 58 V16 Q8 10 14 10 Z" transform="translate(4 4)" fill={C.ink} />
      <path d="M14 10 H120 Q126 10 126 16 V58 Q126 64 120 64 H52 L30 84 L34 64 H14 Q8 64 8 58 V16 Q8 10 14 10 Z" fill={C.terracotta} {...S} />
      <text x="67" y="46" textAnchor="middle" fontFamily="Fraunces, Georgia, serif" fontStyle="italic" fontWeight="600" fontSize="28" fill={C.cream}>{children}</text>
    </svg>
  );
}

// Composition complète pour le hero de la page d'accueil
export default function StudyDesk() {
  return (
    <div className="study-desk" role="img" aria-label="Illustration : bureau d'étude avec ordinateur, lampe, livres, crayons, cahier, lunettes et tasse">
      <DeskLamp className="so so-lamp" />
      <PencilCup className="so so-pencils" />
      <Glasses className="so so-glasses" />
      <Laptop className="so so-laptop" />
      <Bubble className="so so-bubble">hey !</Bubble>
      <Mug className="so so-mug" />
      <BookStack className="so so-books" />
      <Notebook className="so so-notebook" />
      <Sparkle className="so so-spark so-spark-1" />
      <Sparkle className="so so-spark so-spark-2" color={C.blush} />
      <Sparkle className="so so-spark so-spark-3" color={C.oliveLight} />
      <span className="so-dot so-dot-1" />
      <span className="so-dot so-dot-2" />
      <span className="so-dot so-dot-3" />
    </div>
  );
}
